// ===========================
// Localization strings (en)
// ===========================
const en = {
  // Navigation
  nav_home: 'Home',
  nav_about: 'About',
  nav_products: 'Products',
  nav_news: 'News',
  nav_team: 'Team',
  nav_careers: 'Careers',
  nav_contact: 'Contact',

  // Hero Section
  hero_title_line1: 'BUILDING THE',
  hero_title_line2: 'METAVERSE',
  hero_title_line3: 'FUTURE',
  hero_subtitle: 'Pioneer XR Game Studio | B2B Solutions | Global Innovation',
  hero_cta1: 'EXPLORE PRODUCTS',
  hero_cta2: 'PARTNER WITH US',

  // About Section
  about_badge: 'ABOUT THIRDVERSE',
  about_title_line1: 'PIONEERING THE',
  about_title_line2: 'NEXT GENERATION',
  about_title_line3: 'OF XR EXPERIENCES',
  about_description:
    'Thirdverse is a next-generation XR game studio redefining how people play, connect, and experience virtual worlds. Our multidisciplinary team combines bold creative vision with advanced engineering to build immersive, interactive gameplay and social experiences. We challenge conventions and push XR forward—shaping the future of immersive entertainment on a global scale.',
  about_stat1_number: 'ALL XR',
  about_stat1_label: 'PLATFORMS',
  about_stat2_number: 'GLOBAL',
  about_stat2_label: 'REACH',
  about_cta1: 'MANAGEMENT MEMBERS',
  about_cta2: 'COMPANY PROFILE',

  // Products Section
  products_title: 'Our Products',
  products_subtitle: 'Immersive VR Experiences',

  // News Section
  news_title: 'LATEST NEWS',
  news_category_all: 'All News',
  news_category_funding: 'Funding',
  news_category_partnerships: 'Partnerships',
  news_category_product_launches: 'Product Launches',
  news_search_placeholder: 'Search news...',
  news_read_more: 'Read More',
  news_view_all: 'View All News',
  news_show_less: 'Show Less',
  news_back_to_home: 'Back',
  news_share: 'Share',
  news_back_to_list: 'Back',

  // Leadership Section
  leadership_title: 'Management Members',
  leadership_subtitle: 'Meet Our Visionaries',

  // Career Section
  career_title: 'Join Our Team',
  career_subtitle: 'Shape the Future of VR',
  career_description:
    'We are always looking for talented individuals who are passionate about creating the future of virtual reality. Join us in our mission to revolutionize the gaming industry.',
  career_cta: 'View Open Positions',
  career_join_badge: 'JOIN US',
  career_hero_title_line1: 'BUILD THE',
  career_hero_title_line2: 'FUTURE',
  career_hero_title_line3: 'OF XR',
  career_hero_description:
    "Join a world-class team of creators and engineers building immersive XR experiences for players around the world. At Thirdverse, you'll work on ambitious projects that compete on a global stage, shaping interactive worlds at the forefront of virtual reality. We offer competitive compensation, flexible work arrangements, and the opportunity to push the boundaries of what's possible in XR.",
  career_hero_cta: 'VIEW OPEN POSITIONS',

  // Contact Section
  contact_title: 'Get in Touch',
  contact_subtitle: "We'd Love to Hear From You",
  contact_name: 'Name',
  contact_email: 'Email',
  contact_message: 'Message',
  contact_send: 'Send Message',
  contact_success: 'Thank you for your message! We\'ll get back to you soon.',
  contact_error: 'Failed to send message. Please try again.',

  // Footer
  footer_about: 'About',
  footer_products: 'Products',
  footer_news: 'News',
  footer_careers: 'Careers',
  footer_contact: 'Contact',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Service',
  footer_rights: 'All rights reserved.',

  // Careers Page (general)
  careers_title: 'Thirdverse Careers',
  careers_subtitle: 'Join Us in Creating the Future',
  careers_description:
    'We are currently recruiting for all creative positions. Please send your resume and work history to the email address below.',
  careers_email_label: 'Email Address:',

  // 404 Page
  notfound_title: 'Page Not Found',
  notfound_description: 'The page you are looking for does not exist.',
  notfound_back: 'Back to Home',

  // Privacy Policy
  privacy_title: 'Privacy Policy',
  privacy_effective: 'Effective Date: January 1, 2024',

  // Terms of Service
  terms_title: 'Terms of Service',
  terms_effective: 'Effective Date: January 1, 2024',
};

// ===========================
// Additional Careers specific strings
// ===========================
const careers = {
  careers_hero_badge: 'CAREERS',
  careers_hero_title_line1: 'BUILD',
  careers_hero_title_line2: 'THE FUTURE',
  careers_hero_title_line3: 'OF XR',
  careers_hero_description:
    'Join a world-class team of creators and engineers building immersive XR experiences for players around the globe. At Thirdverse, you\'ll work on ambitious projects that compete on the global stage, shaping interactive worlds at the forefront of virtual reality. We offer competitive compensation, flexible work arrangements, and the opportunity to push the boundaries of what\'s possible in XR alongside top talent from around the world.',
  careers_open_position_title: 'Open Positions',
  careers_open_position_subtitle: 'We are always looking for talented individuals.',
  careers_message_line1: 'We are currently recruiting for all creative positions.',
  careers_message_line2: 'Please send your resume and work history to the email address below.',
  careers_note:
    'Only those who pass the document screening will be contacted. Application documents will be strictly managed and will not be used for any purpose other than recruitment.',
};

/**
 * Export a single default object that merges the generic English strings (`en`)
 * with the Careers‑specific overrides (`careers`). In case of key collisions,
 * the values from `careers` take precedence.
 *
 * Using a spread merge guarantees that any future additions to either source
 * are automatically included, while keeping the module's public API simple:
 * one default export.
 */
export default { ...en, ...careers };
